import * as React from "react";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { Dialog } from "../components/organisms/Dialog";
import { Table } from "../components/organisms/Table";
import { EmailComponent } from "../components/templates/EmailComponent";
import { EmailComponentPreview } from "../components/templates/EmailComponentPreview";
import { useZohoAuth } from "../hook/useZohoAuth";
import { zohoApi } from "../zohoApi";
import {
  editor,
  buttonPositions,
  moduleNameMap,
  specialModules,
} from "../config/config";
import { InitialPage } from "../components/organisms/InitialPage";
import { ZOHO_CONN_NAME } from "../config/serviceConstant";
// import { enqueueSnackbar } from "notistack";

const { useState, useEffect, useRef } = React;

const maxWindow = { height: "80%", width: "80%" };
const minWindow = { height: "350", width: "700" };
const minWindowBlueprint = { height: "410", width: "700" };
const SINGLE_RECORD = "singleRecord";
const RELATED_LIST = "relatedList";

export const ButtonRoute = () => {
  const {
    module,
    recordId,
    initZoho,
    accessToken,
    buttonPosition,
    orgId,
    dataCenterUrl,
    zapiKey,
    adminEmail,
    apiKey,
  } = useZohoAuth();

  const [storage, setStorage] = useState();
  const [openTable, setOpenTable] = useState(false);
  const [recordDetailsArr, setRecordDetailsArr] = useState();
  const [finalRecords, setFinalRecords] = useState([]);
  //-------------------
  const [relatedListModule, setRelatedListModule] = useState();
  const [relationshipName, setRelationshipName] = useState();
  const [openEmail, setOpenEmail] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [firstPage, setFirstPage] = useState();
  const [relatedListApis, setRelatedListApis] = useState([]);
  const [relatedListLoading, setRelatedListLoading] = useState();
  const [singleRecordDataLoading, setSingleRecordDataLoading] = useState();
  const [crmUsersEmail, setUsersCrmEmails] = useState([]);
  const [crmUsersEmailLoading, setCrmUsersEmailLoading] = useState(false);
  const [fromEmail, setFromEmail] = useState("");
  const [clickedButton, setClickedButton] = useState();
  //-------------------
  const [subject, setSubject] = useState("");
  const [emailContent, setEmailContent] = React.useState("");
  const [editorType, setEditorType] = useState(editor.rich_text);
  //-------------------
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [emailTemplatesLoading, setEmailTemplatesLoading] = useState(false);
  //-------------------
  const [selectedEmailTemplateId, setSelectedEmailTemplateId] = useState();
  //-------------------
  const [inventoryTemplates, setInventoryTemplates] = useState([]);
  const [inventoryTemplatesLoading, setInventoryTemplatesLoading] =
    useState(false);
  const [selectedInventoryTemplate, setSelectedInventoryTemplate] = useState(
    []
  );
  //-------------------
  const [selectedFallbackEmail, setSelectedFallbackEmail] = React.useState("");
  const [isOwnerEmailSelected, setIsOwnerEmailSelected] = React.useState(false);
  //-------------------
  const [toArray, setToArray] = useState([]);
  const [ccArray, setCcArray] = useState([]);
  const [bccArray, setBccArray] = useState([]);
  //-------------------
  const [headCells, setHeadCells] = useState([]);
  const [emailFields, setEmailFields] = useState([]);
  const emailFieldsRef = useRef();
  const [fileFields, setFileFields] = useState([]);
  const [selected, setSelected] = React.useState([]);
  const [notSelected, setNotSelected] = React.useState([]);
  const [initPageContent, setInitPageContent] = React.useState(
    <CircularProgress />
  );
  //-------------------
  const [emailType, setEmailType] = useState();
  const [recordDataKeys, setRecordDataKeys] = useState([]);

  //-------------------
  const listViewPage = buttonPosition === buttonPositions.ListView;
  const detailViewPage = buttonPosition === buttonPositions.DetailView;
  const listViewEachRecordPage =
    buttonPosition === buttonPositions.ListViewEachRecord;
  const listViewWithoutRecordPage =
    buttonPosition === buttonPositions.ListViewWithoutRecord;
  const blueprintPage = buttonPosition === buttonPositions.BlueprintView;

  // Check if there is accessToken or not.
  useEffect(() => {
    if (accessToken === null) {
      setInitPageContent(<h1>Not authenticated.</h1>);
    }
  }, [accessToken]);

  // Check if this list_view_without_record page.
  useEffect(() => {
    if (listViewWithoutRecordPage) {
      setInitPageContent(<h1>Please select record</h1>);
    }
  }, [listViewWithoutRecordPage]);

  // Resize window for details_view_page and list_view_each_record_page.
  useEffect(() => {
    const r = async () => {
      await zohoApi.auth.resizeWindow(minWindow);
    };
    if ((detailViewPage || listViewEachRecordPage) && initZoho) {
      r();
    }
  }, [detailViewPage, listViewEachRecordPage, initZoho]);

  // Resize window for blueprint page.
  useEffect(() => {
    const r = async () => {
      await zohoApi.auth.resizeWindow(minWindowBlueprint);
    };
    if (blueprintPage && initZoho) {
      r();
    }
  }, [blueprintPage, initZoho]);

  // Fetch org emails.
  useEffect(() => {
    async function getCrmEmails({ accessToken, dataCenterUrl }) {
      setCrmUsersEmailLoading(true);
      const { data: resp, error } = await zohoApi.user.getCrmUsersEmail({
        accessToken,
        dataCenterUrl,
      });

      setUsersCrmEmails(resp);
      setFromEmail(resp?.[0]);

      if (resp?.[0]) {
        setEmailType({ type: "Org email", orgEmail: true });
      } else {
        setEmailType({ type: null, orgEmail: false });
      }

      setCrmUsersEmailLoading(false);
    }
    if (accessToken && dataCenterUrl) {
      getCrmEmails({ accessToken, dataCenterUrl });
    }
  }, [accessToken, dataCenterUrl]);

  // TipTap popover option keys.
  useEffect(() => {
    const getRecordDataKeys = async ({ entity, entityId }) => {
      const resp = await zohoApi.record.getFieldsAndData({ entity, entityId });
      setRecordDataKeys([...Object.keys(resp?.recordData), "userSignature"]);
    };
    if (module && recordId) {
      getRecordDataKeys({
        entity: module,
        entityId: recordId,
      });
    }
  }, [module, recordId]);

  // Set storage for temporary attachment upload.
  useEffect(() => {
    if (module && recordId) {
      setStorage({
        module,
        recordId: Array.isArray(recordId) ? recordId?.[0] : recordId,
      });
    }
    // }, [module, recordId, recordDetailsArr]);
  }, [module, recordId]);

  // Fetch related list apis for autocomplete option in first page.
  useEffect(() => {
    const fetchRelatedListApis = async ({
      module,
      recordId,
      accessToken,
      dataCenterUrl,
    }) => {
      const { data: resp } = await zohoApi.record.getRelatedListApis({
        module,
        accessToken,
        dataCenterUrl,
      });
      // setRelatedListApis(resp);
      //---------
      const temp = [];
      for (const obj of resp) {
        const { data } = await zohoApi.record.getRecordsFromRelatedList({
          module,
          recordId,
          RelatedListAPI: obj?.api_name,
        });
        if (data?.length > 0) {
          temp.push(obj);
        }
      }

      setRelatedListApis(temp);
      setFirstPage(true);
    };
    if (
      module &&
      recordId &&
      accessToken &&
      dataCenterUrl &&
      (detailViewPage || blueprintPage || listViewEachRecordPage)
    ) {
      fetchRelatedListApis({ module, recordId, accessToken, dataCenterUrl });
    }
  }, [
    module,
    recordId,
    accessToken,
    detailViewPage,
    blueprintPage,
    listViewEachRecordPage,
    dataCenterUrl,
  ]);

  // Fetch list view data.
  useEffect(() => {
    const fetchListViewData = async () => {
      if (recordId?.length > 100) {
        setInitPageContent(<h1>Too many records selected.</h1>);
        return;
      }

      const { data: resp } = await zohoApi.record.getEmailAndFileFields({
        module,
        accessToken,
        dataCenterUrl,
      });

      const fileFields = await resp?.fileFields;
      setFileFields(fileFields);
      const tempEmails_resp = await resp?.emailFields;
      setEmailFields(tempEmails_resp);

      const tempNameInListView = moduleNameMap(
        relatedListModule ? relatedListModule : module
      );

      // v1----------------
      // const tempAllEmailFieldsData = [
      //   {
      //     id: tempNameInListView,
      //     fieldDisplayLabel: "Name",
      //     api_name: tempNameInListView,
      //   },
      //   ...tempEmails_resp,
      // ]?.map((el) => {
      //   if (el.id === tempNameInListView) {
      //     return el;
      //   }
      //   return {
      //     id: el?.fieldApiName,
      //     fieldDisplayLabel: el?.field_label,
      //     // groupBy: el?.display_label,
      //     ...el,
      //   };
      // });

      // v2----------------
      // const tempAllEmailFieldsData = [
      //   {
      //     id: tempNameInListView,
      //     fieldDisplayLabel: "Name",
      //     api_name: tempNameInListView,
      //   },
      //   ...tempEmails_resp?.map((el) => {
      //     return {
      //       id: el?.fieldApiName,
      //       fieldDisplayLabel: el?.field_label,
      //       // groupBy: el?.display_label,
      //       ...el,
      //     };
      //   }),
      // ];

      // const tempHeadCells =
      //   tempEmails_resp?.length > 0 ? tempAllEmailFieldsData : [];

      // setHeadCells(tempHeadCells);

      // v3----------------
      setHeadCells([
        {
          id: tempNameInListView,
          fieldDisplayLabel: "Name",
          api_name: tempNameInListView,
        },
        { id: "To", fieldDisplayLabel: "To" },
        { id: "Cc", fieldDisplayLabel: "Cc" },
        { id: "Bcc", fieldDisplayLabel: "Bcc" },
      ]);

      const { data: allEmailFieldsData } =
        await zohoApi.record.getRecordsEmailAndLookupEmail({
          module,
          dataCenterUrl,
          orgId,
          apiKey,
          connName: ZOHO_CONN_NAME,
        });
      emailFieldsRef.current = allEmailFieldsData;

      const emailFieldApis = tempEmails_resp?.map((el) => el?.api_name);
      let ids = "?ids=" + recordId?.join(",");
      let fields =
        `&fields=Owner,${moduleNameMap(module)},` + emailFieldApis?.join(",");

      const { data } = await zohoApi.record.getBulkRecordDetailsRestAPI({
        accessToken,
        url: `${dataCenterUrl}/crm/v6/${module + ids + fields}`,
      });

      setRecordDetailsArr(data);
      setFinalRecords(data);
      setSelected(data?.map((el) => el?.id));
      setNotSelected([]);

      await fetchEmailTemplates({ module, accessToken, dataCenterUrl });

      if (specialModules.includes(module)) {
        await fetchInventoryTemplates({ module, accessToken, dataCenterUrl });
      }

      await zohoApi.auth.resizeWindow(maxWindow);

      setOpenTable(true);
    };

    if (
      module &&
      recordId &&
      apiKey &&
      orgId &&
      accessToken &&
      listViewPage &&
      dataCenterUrl
    ) {
      fetchListViewData();
    }
  }, [
    module,
    recordId,
    accessToken,
    listViewPage,
    dataCenterUrl,
    apiKey,
    orgId,
    relatedListModule,
  ]);

  const getHeadcellFromTable = (field, arr) => {
    if (field === "To") {
      setToArray(arr);
    }
    if (field === "Cc") {
      setCcArray(arr);
    }
    if (field === "Bcc") {
      setBccArray(arr);
    }
  };

  const fetchEmailTemplates = async ({
    module,
    accessToken,
    dataCenterUrl,
  }) => {
    setEmailTemplatesLoading(true);
    const { data: templates } = await zohoApi.email.getEmailTemplateList({
      module,
      accessToken,
      dataCenterUrl,
    });
    setEmailTemplates(templates);
    setEmailTemplatesLoading(false);
  };

  const fetchInventoryTemplates = async ({
    module,
    accessToken,
    dataCenterUrl,
  }) => {
    setInventoryTemplatesLoading(true);

    const { data: inventoryTemplates } =
      await zohoApi.inventory.getInventoryTemplateList({
        module,
        accessToken,
        dataCenterUrl,
      });

    if (inventoryTemplates?.length < 1) {
      setInitPageContent(<h1>No inventory template.</h1>);
      return;
    }

    setInventoryTemplates(inventoryTemplates);
    setInventoryTemplatesLoading(false);
  };

  const onClickSingleRecord = async () => {
    if (module && recordId && accessToken && dataCenterUrl) {
      setSingleRecordDataLoading(true);
      setClickedButton(SINGLE_RECORD);
      setRelatedListModule(undefined);
      setRelationshipName(undefined);
      setRecordDetailsArr(null);
      setFinalRecords(null);
      setSelected([]);

      const { data: allEmailFieldsData } =
        await zohoApi.record.getRecordsEmailAndLookupEmail({
          module,
          dataCenterUrl,
          record_id: recordId[0] ? recordId[0] : recordId,
          orgId,
          apiKey,
          connName: ZOHO_CONN_NAME,
        });

      setEmailFields(allEmailFieldsData);

      const tempNameInSR = moduleNameMap(
        relatedListModule ? relatedListModule : module
      );

      // const tempAllEmailFieldsData = [
      //   {
      //     id: tempNameInSR,
      //     fieldDisplayLabel: "Name",
      //     api_name: module + "." + moduleNameMap(module),
      //   },
      //   ...allEmailFieldsData?.map((el) => ({
      //     id: el?.fieldApiName,
      //     ...el,
      //   })),
      // ];

      // const tempHeadCells =
      //   allEmailFieldsData?.length > 0 ? tempAllEmailFieldsData : [];

      // setHeadCells(tempHeadCells);

      setHeadCells([
        {
          id: tempNameInSR,
          fieldDisplayLabel: "Name",
          api_name: module + "." + moduleNameMap(module),
        },
        { id: "To", fieldDisplayLabel: "To" },
        { id: "Cc", fieldDisplayLabel: "Cc" },
        { id: "Bcc", fieldDisplayLabel: "Bcc" },
      ]);

      const { data: filedData } = await zohoApi.record.getEmailAndFileFields({
        module,
        accessToken,
        dataCenterUrl,
      });
      //------------
      const fileFields = await filedData?.fileFields;

      setFileFields(fileFields);
      const tempEmails = allEmailFieldsData?.map(
        (el) => el?.fieldApiName || el?.fieldDisplayLabel
      );
      let ids;
      if (typeof recordId === "string") {
        ids = "?ids=" + recordId;
      } else {
        ids = "?ids=" + recordId?.join(",");
      }
      let fields =
        `&fields=Owner,${moduleNameMap(module)},` + tempEmails?.join(",");

      const { data } = await zohoApi.record.getBulkRecordDetailsRestAPI({
        accessToken,
        url: `${dataCenterUrl}/crm/v6/${module + ids + fields}`,
      });
      setRecordDetailsArr(data);
      setFinalRecords(data);
      // "setSelected" takes array of id.
      // and in onClickSingleRecord data array has single object.
      setSelected([data?.[0]?.id]);
      setNotSelected([]);
      // for single record "getPassedIds" return original arr of object. so, no "getFailedIds".
      // const passedIdArr = getPassedIds({ arr: data, tempEmails });
      // setSelected(passedIdArr);

      await fetchEmailTemplates({ module, accessToken, dataCenterUrl });

      if (specialModules.includes(module)) {
        await fetchInventoryTemplates({ module, accessToken, dataCenterUrl });
      }

      await zohoApi.auth.resizeWindow(maxWindow);

      setOpenEmail(true);
      setSingleRecordDataLoading(false);
    }
  };

  const onSelectAutocomplete = async (e, value) => {
    if (value) {
      setRelatedListLoading(true);
      setClickedButton(RELATED_LIST);
      const newModule = value?.module?.api_name;
      const relationshipName = value?.api_name;
      setRelatedListModule(newModule);
      setRelationshipName(relationshipName);
      setRecordDetailsArr(null);
      setFinalRecords(null);
      setSelected([]);

      const { data: allEmailFieldsData } =
        await zohoApi.record.getRecordsEmailAndLookupEmail({
          module: newModule,
          dataCenterUrl,
          orgId,
          apiKey,
          connName: ZOHO_CONN_NAME,
        });

      setEmailFields(allEmailFieldsData);

      const tempNameInAutocomplete = moduleNameMap(
        relatedListModule ? relatedListModule : module
      );

      // const tempAllEmailFieldsData = [
      //   {
      //     id: tempNameInAutocomplete,
      //     fieldDisplayLabel: "Name",
      //     api_name: module + "." + moduleNameMap(module),
      //   },
      //   ...allEmailFieldsData?.map((el) => ({
      //     id: el?.fieldApiName,
      //     ...el,
      //   })),
      // ];

      // const tempHeadCells =
      //   allEmailFieldsData?.length > 0 ? tempAllEmailFieldsData : [];

      // setHeadCells(tempHeadCells);

      setHeadCells([
        {
          id: tempNameInAutocomplete,
          fieldDisplayLabel: "Name",
          api_name: module + "." + moduleNameMap(module),
        },
        { id: "To", fieldDisplayLabel: "To" },
        { id: "Cc", fieldDisplayLabel: "Cc" },
        { id: "Bcc", fieldDisplayLabel: "Bcc" },
      ]);

      const { data: emailAndFileFields } =
        await zohoApi.record.getEmailAndFileFields({
          module,
          accessToken,
          dataCenterUrl,
        });
      //------------
      const fileFields = await emailAndFileFields?.fileFields;
      setFileFields(fileFields);

      const { data } =
        await zohoApi.record.getRecordsFromRelatedListFlattenData({
          module,
          recordId,
          RelatedListAPI: relationshipName,
          relatedListModule: newModule,
        });

      if (data?.length < 1) {
        setInitPageContent(<h1>No record found in Related Module</h1>);
        handleFirstPageClose();
        return;
      }

      setRecordDetailsArr(data);
      setFinalRecords([]);
      setSelected([]);
      const tempSelected = data?.map((el) => {
        return el[newModule + ".id"];
      });
      setNotSelected(tempSelected);

      await fetchEmailTemplates({
        module: newModule,
        accessToken,
        dataCenterUrl,
      });

      if (specialModules.includes(newModule)) {
        await fetchInventoryTemplates({
          module: newModule,
          accessToken,
          dataCenterUrl,
        });
      }

      await zohoApi.auth.resizeWindow(maxWindow);

      setOpenTable(true);
      setRelatedListLoading(false);
    }
  };

  const onSelectAllTableItem = (event, module) => {
    setSelected((pre) => {
      if (pre?.length > 0) {
        return [];
      }
      return recordDetailsArr?.map((el) => {
        const rowId = el.id ? el.id : el[module + ".id"];
        return rowId;
      });
    });
    setFinalRecords((pre) => {
      if (pre?.length > 0) {
        return [];
      }
      return recordDetailsArr;
    });
  };

  const onSelectSingleTableItem = (rowId, record) => {
    const tempModule = relatedListModule ? relatedListModule : module;
    setSelected((pre) => {
      return pre.includes(rowId)
        ? pre.filter((id) => id !== rowId)
        : [...pre, rowId];
    });
    setFinalRecords((prevRecords) => {
      const recordExists = prevRecords.some((record) => {
        const recordId = record?.id || record?.[`${tempModule}.id`];
        return recordId === rowId;
      });

      // Deselect: Remove the item from the records
      if (recordExists) {
        return prevRecords.filter((record) => {
          const recordId = record?.id || record?.[`${tempModule}.id`];
          return recordId !== rowId;
        });
      }

      // Select: Add the item to the records
      return [...prevRecords, record];
    });
  };

  const handleFirstPageClose = () => {
    setFirstPage(false);
  };

  const handleTableNext = () => {
    if (emailFieldsRef.current) {
      const tem = emailFields;
      setEmailFields(emailFieldsRef.current);
      emailFieldsRef.current = tem;
    }

    setOpenEmail(true);
    // setOpenTable(false);
  };

  const handleTableBack = () => {
    zohoApi.auth.resizeWindow(blueprintPage ? minWindowBlueprint : minWindow);
    setClickedButton(undefined);
    setRelatedListModule(undefined);
    setRelationshipName(undefined);
    setOpenTable(false);
    setOpenEmail(false);
  };

  const handleEmailBack = () => {
    if (emailFieldsRef.current) {
      const tem = emailFields;
      setEmailFields(emailFieldsRef.current);
      emailFieldsRef.current = tem;
    }

    if (!!relatedListModule) {
      setSelected([]);
    }

    setOpenEmail(false);
    setToArray([]);
    setCcArray([]);
    setBccArray([]);
    if (clickedButton === RELATED_LIST) {
      setFinalRecords([]);
    }

    if (listViewPage || !!relatedListModule) {
      setOpenTable(true);
    } else {
      zohoApi.auth.resizeWindow(blueprintPage ? minWindowBlueprint : minWindow);
    }
  };

  const handlePreviewClose = () => {
    setOpenPreview(false);
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          pt: "30px",
          pl: "30px",
          pr: "30px",
          bgcolor: "rgba(245, 245, 245, 1)",
          display: "grid",
          placeItems: "center",
        }}
      >
        {initPageContent}
      </Box>

      <Dialog dialogOpen={firstPage} handleDialogClose={() => {}}>
        <InitialPage
          singleRecordDataLoading={singleRecordDataLoading}
          relatedListLoading={relatedListLoading}
          onClickSingleRecord={onClickSingleRecord}
          relatedListApis={relatedListApis}
          onSelectAutocomplete={onSelectAutocomplete}
          customActionPage={false}
          blueprintPage={blueprintPage}
        />
      </Dialog>

      <Dialog dialogOpen={openTable} handleDialogClose={handleTableBack}>
        <Table
          module={relatedListModule ? relatedListModule : module}
          relatedListModule={relatedListModule}
          rows={recordDetailsArr}
          handleSelectRow={onSelectSingleTableItem}
          handleSelectAllClick={onSelectAllTableItem}
          selected={selected}
          // notSelected={notSelected}
          emailFields={emailFields}
          handleTableNext={handleTableNext}
          handleTableBack={handleTableBack}
          listViewPage={listViewPage}
          headCells={headCells}
          getHeadcellFromTable={getHeadcellFromTable}
          toArray={toArray}
          ccArray={ccArray}
          bccArray={bccArray}
        />
      </Dialog>

      <Dialog dialogOpen={openEmail} handleDialogClose={handleEmailBack}>
        <EmailComponent
          module={module}
          recordId={recordId}
          orgId={orgId}
          apiKey={apiKey}
          zapiKey={zapiKey}
          accessToken={accessToken}
          relatedListModule={relatedListModule}
          setRelatedListModule={setRelatedListModule}
          relationshipName={relationshipName}
          setRelationshipName={setRelationshipName}
          freeSolo={finalRecords?.length === 1}
          noParentRecord={buttonPosition === buttonPositions.ListView}
          handleEmailBack={handleEmailBack}
          //------
          crmUsersEmail={crmUsersEmail}
          crmUsersEmailLoading={crmUsersEmailLoading}
          //------
          selectedEmailTemplateId={selectedEmailTemplateId}
          setSelectedEmailTemplateId={setSelectedEmailTemplateId}
          //------
          emailType={emailType}
          setEmailType={setEmailType}
          //------
          fromEmail={fromEmail}
          setFromEmail={setFromEmail}
          //------
          emailTemplates={emailTemplates}
          emailTemplatesLoading={emailTemplatesLoading}
          //------
          inventoryTemplates={inventoryTemplates}
          inventoryTemplatesLoading={inventoryTemplatesLoading}
          selectedInventoryTemplate={selectedInventoryTemplate}
          setSelectedInventoryTemplate={setSelectedInventoryTemplate}
          //------
          selectedFallbackEmail={selectedFallbackEmail}
          setSelectedFallbackEmail={setSelectedFallbackEmail}
          isOwnerEmailSelected={isOwnerEmailSelected}
          setIsOwnerEmailSelected={setIsOwnerEmailSelected}
          //------
          storage={storage}
          emailOptions={emailFields}
          finalRecords={finalRecords}
          inventoryModule={
            relatedListModule
              ? specialModules.includes(relatedListModule)
              : specialModules.includes(module)
          }
          dataCenterUrl={dataCenterUrl}
          //------
          subject={subject}
          setSubject={setSubject}
          emailContent={emailContent}
          setEmailContent={setEmailContent}
          editorType={editorType}
          setEditorType={setEditorType}
          //------
          adminEmail={adminEmail}
          handlePreviewOpen={() => {
            setOpenPreview(true);
          }}
          //------
          recordDataKeys={recordDataKeys}
          //------
          singlePage={
            (detailViewPage || blueprintPage || listViewEachRecordPage) &&
            !relatedListModule
          }
          listViewPage={listViewPage}
          //-----------
          toArray={toArray}
          setToArray={setToArray}
          ccArray={ccArray}
          setCcArray={setCcArray}
          bccArray={bccArray}
          setBccArray={setBccArray}
          showNumberOfContactsLine={true}
        />
      </Dialog>

      <Dialog dialogOpen={openPreview} handleDialogClose={handlePreviewClose}>
        <EmailComponentPreview
          module={module}
          relatedListModule={relatedListModule}
          finalRecords={finalRecords}
          subject={subject}
          emailContent={emailContent}
          handlePreviewClose={handlePreviewClose}
          orgId={orgId}
          apiKey={apiKey}
          dataCenterUrl={dataCenterUrl}
          fromEmail={fromEmail}
        />
      </Dialog>
    </>
  );
};
